import { Payment, PaymentPageType, usePaymentPage } from "@/api/payment-pages"
import PaymentForm from "./payment.form"
import { useNavigate, useParams } from "react-router-dom"
import { useDynamicContext } from "@dynamic-labs/sdk-react-core"
import { useUserIfAuthenticated } from "@/api/users"
import { PaymentLinkType } from "@/api/payment-links"
import HomeFrame from "./home.frame"

export default function HomeScreen() {
  const { shortId } = useParams()
  const { paymentPage, networks, token, amount, customerEmail, customerName } =
    usePaymentPage(shortId!)
  const { isAuthenticated } = useDynamicContext()
  const { user } = useUserIfAuthenticated()
  const navigate = useNavigate()

  if (!paymentPage || (!user && isAuthenticated)) {
    return null
  }

  return (
    <HomeFrame shortId={shortId!} token={token}>
      <PaymentForm
        shortId={shortId!}
        onReady={(payment: Payment) =>
          navigate(`/${shortId}/pay-with-external`, { state: { payment } })
        }
        networks={networks}
        token={token}
        collectData={
          paymentPage.type === PaymentPageType.PAYMENT_LINK && !isAuthenticated
        }
        amountOptions={
          paymentPage.paymentLink?.type === PaymentLinkType.CUSTOM_AMOUNT
            ? {
                min: paymentPage.paymentLink.minAmount,
                max: paymentPage.paymentLink.maxAmount,
                presetAmounts: paymentPage.paymentLink.presetAmounts,
              }
            : undefined
        }
        defaultValues={{
          amount: String(amount),
          email: user ? user.email : customerEmail,
          name: user ? `${user.firstName} ${user.lastName}` : customerName,
          network: networks[0],
        }}
      />
    </HomeFrame>
  )
}
